import {
  formatRelative as dateFnsFormatRelative,
  isValid,
  parseISO,
  parseJSON,
  formatDistanceToNowStrict,
} from 'date-fns'
import { formatInTimeZone, zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz'
import trans from '~/translations/trans'

export const formatDate = (date: Date, formatStr: string) => {
  return formatInTimeZone(date, window.c.timezone, formatStr, {
    locale: window.localeFns,
  })
}
export const formatDistance = (date: Date) => {
  return formatDistanceToNowStrict(date, {
    addSuffix: true,
    locale: {
      ...window.localeFns,
    },
  })
}

export const formatRelative = (date: Date) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const utc = zonedTimeToUtc(date, timezone)
  const zoned = utcToZonedTime(utc, window.c.timezone)

  const formatRelativeLocale = {
    lastWeek: 'PPPP',
    yesterday: `'${trans.date.yesterday()}'`,
    today: `'${trans.date.today()}'`,
    tomorrow: 'PPPP',
    nextWeek: 'PPPP',
    other: 'PPPP',
  }

  return dateFnsFormatRelative(zoned, new Date(), {
    locale: {
      ...window.localeFns,
      formatRelative: token => formatRelativeLocale[token],
    },
  })
}

export const parseJsonDate = (val: any) => {
  const date = typeof val == 'string' && parseJSON(val)

  return isValid(date) ? date : false
}

export const parseIsoDate = (val: any) => {
  const date = typeof val == 'string' && parseISO(val)

  return isValid(date) ? date : false
}
